/**
 * Created by daniesy on 09/11/2016.
 */
const d3 = require('d3');

import Chart from './chart.js';
import ChartData from './chartData.js';

export default class Question {
    constructor(title, text, answer) {
        this.title = title;
        this.text = text;
        this.answer = answer;
        this.answers = ['Did Better', 'Did Worse'];
        this.correct = false;
        this.data = [];
        this.onFinished = () => {};
    }

    addData(data) {
        this.data.push(data);
    }

    drawChart(element, width, height, hasCourtain = true) {
        const chartData = new ChartData(this.data);
        this.chart = new Chart({element, width, height, dateFormat: '%m/%y', margins: {top: 0, right: 0, bottom: 40, left: 30}})
            .addLine(chartData.spx, 'S&P 500 Total Return', 'spx')
            .addLine(chartData.cta, 'CTA Index', 'cta')
            .draw(hasCourtain);
    }

    drawInElement(element) {
        this.questionElement = element
            .append('div')
            .attr('class', 'question');

        let questionWrapper = this.questionElement
            .append('div')
            .attr('class', 'question__wrapper');

        this.questionTextElement = questionWrapper.append('p')
            .attr('class', 'question__text');

        this.questionTextElement.html(this.text).append('img').attr('src', 'assets/question.svg');

        questionWrapper.append('div').attr('class', 'question__chart');

        this.questionButtons = questionWrapper.append('div')
            .attr('class', 'question__buttons');

        let width = questionWrapper.node().getBoundingClientRect().width / 1.4;
        let height = Math.min(1000, (this.questionElement.node().getBoundingClientRect().height - this.questionButtons.node().getBoundingClientRect().height - 150) / 1.4);

        this.drawChart('.question__chart', width, height, true);

        const that = this;
        this.answers.forEach(element => {
            const button = this.questionButtons.append('button').attr("class", "button__answer").text(element);
            button.on('click', function () {
                that.correct = this.innerText === that.answer;
                that.answered(this);
            })
        });

        this.questionElement.classed('question--visible', true);
    }

    drawInElementAnswered(element, correct) {
        this.questionElement = element
            .append('div')
            .attr('class', 'question question--answered')
            .classed('question--correct', correct)
            .classed('question--incorrect', !correct);

        let questionWrapper = this.questionElement
            .append('div')
            .attr('class', 'question__wrapper');

        this.questionTextElement = questionWrapper.append('p')
            .attr('class', 'question__text');

        this.questionTextElement.text(correct ? "Correct, the CTA Index did better than the S&P 500." : "Incorrect, the CTA Index did better than the S&P 500.");

        questionWrapper.append('div').attr('class', 'question__chart');

        this.questionButtons = questionWrapper.append('div')
            .attr('class', 'question__buttons');

        let width = questionWrapper.node().getBoundingClientRect().width / 1.4;
        let height = this.questionElement.node().getBoundingClientRect().height / 1.4 - (this.questionButtons.node().getBoundingClientRect().height / 1.4 + 100);

        this.drawChart('.question__chart', width, height, false);

        this.questionElement.classed('question--visible', true);

        this.questionButtons.append('button').attr('class', 'question__close').html('Continue').on('click', () => {
            this.questionElement.classed('question--visible', false);

            setTimeout(() => this.questionElement.remove(), 500);

            this.onFinished();
        });
    }

    answered(button) {
        button.className = this.correct ? "correct" : "incorrect";
        this.questionElement
            .classed('question--answered', true)
            .classed('question--correct', this.correct)
            .classed('question--incorrect', !this.correct)
            .selectAll('button')
            .remove();

        this.questionTextElement.text(this.correct ? "Correct, the CTA Index did better than the S&P 500." : "Incorrect, the CTA Index did better than the S&P 500.");

        this.showContinue(this.correct);
        this.chart.animate(3000);
    }

    showContinue(correct) {
        this.questionButtons.append('button').attr('class', 'question__close').html('Continue').on('click', () => {
            this.questionElement.classed('question--visible', false);

            setTimeout(() => this.questionElement.remove(), 500);

            this.onFinished(correct);
        });
    }
}



// WEBPACK FOOTER //
// ./src/js/question.js